import { UpdatedDateField } from './main';
import { useUpdatedDateField } from './services';

export default UpdatedDateField;
export { useUpdatedDateField };
